module.exports = __webpack_public_path__ + "static/img/card-003.8fc983a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-003.png
// module id = oC3M
// module chunks = 1